import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { PageHero } from '../components/PageHero';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '../components/ui/accordion';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { FAQ_ITEMS } from '../lib/pageContent';
import { FAQ_PAGE } from '../constants/testIds';

const META_DESCRIPTION =
  'Answers to the most common questions about buying bulk wholesale used tires: minimum order quantities, container sizes, tire grading, international shipping, customs documentation and payment terms.';

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: FAQ_ITEMS.map((item) => ({
    '@type': 'Question',
    name: item.q,
    acceptedAnswer: { '@type': 'Answer', text: item.a },
  })),
};

export default function FAQPage() {
  useDocumentMeta('Bulk Used Tire FAQ — Shipping, Grading & Orders | BulkUsedTires.com', META_DESCRIPTION);

  return (
    <div className="min-h-screen bg-brand-bg">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }} />
      <Navbar />
      <PageHero
        eyebrow="FAQ"
        title="Frequently Asked Questions"
        description="Everything wholesale buyers ask us before placing their first bulk container order."
      />
      <section data-testid={FAQ_PAGE.section} className="py-16 sm:py-20">
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          <Accordion type="single" collapsible defaultValue="faq-0" className="w-full">
            {FAQ_ITEMS.map((item, i) => (
              <AccordionItem key={item.q} value={`faq-${i}`} data-testid={FAQ_PAGE.item(i)} className="border-brand-border">
                <AccordionTrigger
                  data-testid={FAQ_PAGE.question(i)}
                  className="font-display font-bold uppercase text-brand-text text-base sm:text-lg hover:no-underline hover:text-brand-orange"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent data-testid={FAQ_PAGE.answer(i)} className="text-brand-muted text-sm sm:text-base leading-relaxed">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="mt-14 rounded-2xl border border-brand-border bg-brand-surface p-7 sm:p-9 text-center">
            <p className="font-display font-bold uppercase text-brand-text text-xl sm:text-2xl">Still have questions?</p>
            <p className="mt-2 text-brand-muted text-sm sm:text-base">Talk to our team about your sizing, grading and destination port needs.</p>
            <a
              href="/#order-form"
              className="mt-5 inline-flex items-center gap-2 bg-brand-orange hover:bg-brand-orangeHover text-white font-display font-bold uppercase tracking-wide rounded-full px-7 py-3 transition-colors"
            >
              Request a Quote
            </a>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
